export default "__VITE_ASSET__CgMbyScL__"